import { Storybook } from "@tento-ui/ui/storybook";
import { DebugResolvedSheetPanel } from "./debug-resolved-sheet-panel";
import { SheetId } from "@tento-lona/sheets";

export class DebugResolvedSheetPanelStoryBook extends Storybook.Default {
  title(): string {
    return "Debug Resolved Sheet Panel";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "All Fields",
        render: () => {
          return DebugResolvedSheetPanel.make().bind({
            state: "loaded",
            lookupKey: ":~lona:home",
            ownerId: "user_abc123",
            userSheetId: SheetId.of("ss_000000000000000000000000000c0de1"),
          });
        },
      },
      {
        title: "Minimal (State Only)",
        render: () => {
          return DebugResolvedSheetPanel.make().bind({
            state: "pending",
          });
        },
      },
      {
        title: "Reserved Key Sheet",
        render: () => {
          return DebugResolvedSheetPanel.make().bind({
            state: "loaded",
            lookupKey: ":~lona:tasks",
          });
        },
      },
      {
        title: "User Sheet",
        render: () => {
          return DebugResolvedSheetPanel.make().bind({
            state: "loaded",
            ownerId: "user_def456",
            userSheetId: SheetId.of("ss_000000000000000000000000000c0de2"),
          });
        },
      },
    ];
  }
}
